// Utility to format numbers based on currency system
export function formatDealValue(value?: number, currency?: string): string {
  if (!value) return "0";

  const currencyCode = currency?.toUpperCase();
  const useIndianSystem = currencyCode === 'INR';

  if (useIndianSystem) {
    // Indian system: Lakh, Crore
    if (value >= 10000000) {
      // Crore
      return `${(value / 10000000).toFixed(2)} Cr`;
    } else if (value >= 100000) {
      // Lakh
      return `${(value / 100000).toFixed(2)} L`;
    } else if (value >= 1000) {
      // Thousand
      return `${(value / 1000).toFixed(2)} K`;
    } else {
      // Indian number formatting
      return value.toLocaleString('en-IN');
    }
  } else {
    // International system: K, M, B, T
    if (value >= 1000000000000) {
      // Trillion
      return `${(value / 1000000000000).toFixed(2)} T`;
    } else if (value >= 1000000000) {
      // Billion
      return `${(value / 1000000000).toFixed(2)} B`;
    } else if (value >= 1000000) {
      // Million
      return `${(value / 1000000).toFixed(2)} M`;
    } else if (value >= 1000) {
      // Thousand
      return `${(value / 1000).toFixed(2)} K`;
    } else {
      // Regular number formatting
      return value.toLocaleString('en-US');
    }
  }
}

// Legacy function for backward compatibility
export function formatDealValueLegacy(value?: number): string {
  return formatDealValue(value, 'INR');
}
